import styled from "@emotion/styled";
import { Button } from "react-aria-components";

export const CustomDialogCloseButton = styled(Button)`
  position: absolute;
  right: 8px;
  top: 8px;
  background: transparent;
  border: none;
`;
